export default __webpack_public_path__ + "static/media/congracts.6f0194c5.png";